export const getSliderRouteParams = (row, appSlider = false) => {
  return {
      pathname: appSlider ? '/app-sliders' : '/sliders',
      search: `sliderable_type=category&sliderable_id=${row.original.id}`,
  }
}

export const btnStyle = {
  color: '#fff',
  borderRadius: '4px',
  padding: '8px',
  cursor: 'pointer',
  margin: '0 2px',
  width: '75px',
  display: 'inline-block',
  marginTop: '-5px',
  marginBottom: '-5px',
}



// WEBPACK FOOTER //
// ./src/containers/Categories/common.js